"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var DocExpire = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M11,20 L7,20 C6.44771525,20 6,19.5522847 6,19 L6,6 C6,5.44771525 6.44771525,5 7,5 L12.7099045,5 L17,9.2995551 L17,11 L16,11 L16,10 L12,10 L12,6 L7,6 L7,19 L11,19 L11,20 Z M13,6.70710678 L13,9 L15.2928932,9 L13,6.70710678 Z M16.4983444,15.7913331 L19.1416786,13.1463165 C19.3369408,12.9510544 19.6535233,12.9510544 19.8487854,13.1463165 C20.0440475,13.3415787 20.0440475,13.6581612 19.8487854,13.8534233 L17.2052263,16.4986649 L19.8487854,19.1439064 C20.0440475,19.3391685 20.0440475,19.655751 19.8487854,19.8510132 C19.6535233,20.0462753 19.3369408,20.0462753 19.1416786,19.8510132 L16.4983444,17.2059967 L13.8550102,19.8510132 C13.6597481,20.0462753 13.3431656,20.0462753 13.1479034,19.8510132 C12.9526413,19.655751 12.9526413,19.3391685 13.1479034,19.1439064 L15.7914625,16.4986649 L13.1479034,13.8534233 C12.9526413,13.6581612 12.9526413,13.3415787 13.1479034,13.1463165 C13.3431656,12.9510544 13.6597481,12.9510544 13.8550102,13.1463165 L16.4983444,15.7913331 Z" })));
};
DocExpire.displayName = 'DocExpire';
exports.default = DocExpire;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=DocExpire.js.map